import React, { useState } from "react";
import { FaRegLightbulb } from "react-icons/fa6";
import { PiWarningCircle } from "react-icons/pi";

const PaymentForm = () => {
  const [plan, setPlan] = useState("stn");
  return (
    <div className="min-h-screen bg-white flex flex-col justify-between px-4 pt-10 pb-6">
      <div className="max-w-3xl mx-auto w-full">
        {/* Header */}
        <h2 className="text-[2.5rem] font-extrabold mb-2 leading-[3.1rem] text-start">
          Start your{" "}
          <div className="relative inline w-fit">
            free{" "}
            <div className="absolute -bottom-0 bg-slate-400 left-0 w-[90%] -rotate-3 h-1"></div>
          </div>{" "}
          trial now & instantly notify candidates
        </h2>
        <p className="text-base font-medium text-center text-stone-700 bg-stone-100 flex items-center gap-2   p-3 rounded mb-8">
          <FaRegLightbulb className="w-5" /> 80% of employers who post a job on
          Questhire get a quality candidate within the first day!
        </p>
        <div className="flex flex-col gap-2">
          <h2 className="text-2xl font-extrabold">
            Select your free trial level
          </h2>
          <div>
            <div className="tracking-wide text-[.9rem] flex">
              <p>
                Enjoy your free trial until{" "}
                <span className="font-bold">Thursday, July 17, 2025</span>
              </p>
              <p>
                <PiWarningCircle className="inline mr-2" />
                Upgrade, downgrade or cancel at any time.
              </p>
            </div>
            <p className="tracking-wide text-[.9rem] ">
              Only <span className="font-bold">$24.00/day per job</span> after
              your trial ends.
            </p>
          </div>
          {/* Plan Selection */}
          <div className="flex flex-col md:flex-row gap-6 mb-10">
            <div
              className={`w-full border border-gray-300 p-5 rounded-md ${plan === "stn" ? "border-black" : ""
                }`}
            >
              <label className="flex items-start gap-2">
                <input
                  type="radio"
                  onClick={() => setPlan("stn")}
                  checked={plan === "stn" ? true : false}
                  name="plan"
      className="mt-1"
                  defaultChecked
                />
                <div>
                  <p className="font-bold">Standard</p>
                  <p className="text-sm text-gray-600">
                    Great for hiring on a budget
                  </p>
                  <p className="text-sm text-gray-700 mt-1">
                    ✓ Distribution to 100+ job boards
                  </p>
                </div>
              </label>
            </div>
            <div
              className={`w-full border border-gray-300 p-5 rounded-md ${plan === "prem" ? "border-black" : ""
                }`}
            >
              <label className="flex items-start gap-2">
                <input
                  type="radio"
                  onClick={() => setPlan("prem")}
                  checked={plan === "prem" ? true : false}
      className="mt-1"
                  name="plan"
                />
                <div>
                  <p className="font-bold">Premium</p>
                  <p className="text-sm text-gray-600">
                    The best way to hire fast
                  </p>
                  <ul className="text-sm text-gray-700 list-disc ml-5 mt-1">
                    <li>Distribution to 100+ job boards</li>
                    <li>Premium placement in job alert emails</li>
                    <li>
                      Over 43M Resumes in the ZipRecruiter Resume Database
                    </li>
                  </ul>
                </div>
              </label>
            </div>
          </div>
        </div>
        {/* Payment Form */}
        <form className="space-y-4">
          <h3 className="font-bold text-lg">
            Enter your credit card to start your{" "}
            <span className="underline">free</span> trial
          </h3>

          <input
            type="text"
            placeholder="Name on credit card"
            className="w-full border border-gray-300 rounded px-4 py-2"
          />
          <input
            type="text"
            placeholder="Credit card number"
            className="w-full border border-gray-300 rounded px-4 py-2"
          />

          <div className="flex gap-4">
            <input
              type="text"
              placeholder="Exp. month (MM)"
              className="w-full border border-gray-300 rounded px-4 py-2"
            />
            <input
              type="text"
              placeholder="Exp. year (YY)"
              className="w-full border border-gray-300 rounded px-4 py-2"
            />
            <input
              type="text"
              placeholder="CVV"
              className="w-full border border-gray-300 rounded px-4 py-2"
            />
          </div>

          <input
            type="text"
            placeholder="Billing address"
            className="w-full border border-gray-300 rounded px-4 py-2"
          />

          <div className="flex gap-4">
            <input
              type="text"
              placeholder="City"
              className="w-full border border-gray-300 rounded px-4 py-2"
            />
            <input
              type="text"
              placeholder="State"
              className="w-full border border-gray-300 rounded px-4 py-2"
            />
            <input
              type="text"
              placeholder="Zip code"
              className="w-full border border-gray-300 rounded px-4 py-2"
            />
          </div>

          <div className="flex items-start gap-2 text-sm">
            <input type="checkbox" className="mt-1" />
            <label>
              I understand that, after the free trial, I will be charged $24.00
              USD per day per active job. I’ll be billed monthly, when my
              account reaches $500, or upon cancellation, whichever comes first.
              I can cancel at any time.
            </label>
          </div>

          <button
            type="submit"
            className="bg-black text-white font-semibold w-full py-2 rounded hover:bg-white hover:text-black border border-black"
          >
            Post My Job Now
          </button>

          <p className="text-center text-sm mt-4">
            Have Questions? Call{" "}
            <a href="tel:8554583347" className="underline font-semibold">
              (855) 458-3347
            </a>{" "}
            or visit the{" "}
            <span className="underline font-semibold">
              Employer Help Center
            </span>
            .
          </p>
        </form>
      </div>
    </div>
  );
};

export default PaymentForm;
